export default __webpack_public_path__ + "static/media/icone-divisao.4fb37225.svg";